import React from "react";
import { NakiNigunAlbumTrackProducerEditModalTemplate } from "themes/administration/naki-nigun/components";

class NakiNigunAlbumTrackProducerEditModal extends React.Component {
    render() {
        return <NakiNigunAlbumTrackProducerEditModalTemplate {...this.props} />;
    }
}

export default NakiNigunAlbumTrackProducerEditModal;
